export enum TipoModalCarregando {
    Carregando,
    CarregandoLista,
    Exportando
}
